<template>
	<button
		class="btn font-semibold rounded-lg"
		@click="$emit('click', $event)"
		:disabled="loading"
	>
		<span v-if="!loading">
			<slot></slot>
		</span>
		<Spinner :orange="spinnerOrange" class="mx-auto" v-if="loading" />
	</button>
</template>

<script>
    import Spinner from "./Spinner";
	export default {
		components: {Spinner},
		props: {
    		loading: {
    			type: Boolean,
				required: true,
				default: false,
			},
			spinnerOrange: {
				type: Boolean,
				required: false,
				default: false,
			}
		},
        name: "LoadingButton"
    }
</script>

<style scoped>

</style>
